import React, { useEffect, useRef, useState } from "react";
import LandingPageLayout, {
  Header,
} from "../../shared/Layouts/LandingPageLayout";
import { motion } from "framer-motion";
import { FaVolumeMute, FaVolumeUp } from "react-icons/fa";
import { Tooltip } from "@mui/material";
import { SEARCH_ICON, SEARCH_INPUT_WHITE } from "../../assets";
import { useNavigate } from "react-router-dom";

function Hero() {
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch((error) => {
          console.warn("Autoplay blocked:", error);
        });
      }
    }
  }, []);
  return (
    <div
      id="hero-section"
      className="w-full relative lg:h-screen h-[600px] overflow-hidden"
    >
      <div className="w-full h-full absolute inset-0">
        <video
          ref={videoRef}
          autoPlay
          playsInline
          loop
          muted={isMuted}
          className="w-full h-full object-cover"
        >
          <source src="/video/home-hero-video.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="absolute inset-0 bg-[#00000099] z-10"></div>
      <Tooltip title={`${isMuted ? "Unmute" : "Mute"}`}>
        <div
          className="absolute lg:flex hidden right-6 top-6 z-[999] p-3 rounded-full bg-white/10 backdrop-blur-md border border-white/20 shadow-xl cursor-pointer hover:scale-105 transition-transform duration-300 group"
          onClick={() => setIsMuted((prev) => !prev)}
        >
          {isMuted ? (
            <FaVolumeMute className="text-red-400 text-xl group-hover:text-red-500 transition-colors duration-300" />
          ) : (
            <FaVolumeUp className="text-green-400 text-xl group-hover:text-green-500 transition-colors duration-300" />
          )}
        </div>
      </Tooltip>

      <Header />
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        className="absolute flex-col gap-y-4 inset-0 lg:mt-7 mt-20 flex z-40 items-center text-white justify-center"
      >
        <span className="lg:text-[43px]  text-3xl font-bold text-center lg:leading-[50px] leading-[40px]">
          Smarter Property Decisions. Verified <br /> Legal Status. Peace of
          Mind.
        </span>
        <p className="lg:text-lg text-sm font-medium text-center">
          Empowering buyers, investors, and legal professionals with fast,
          reliable access to <br /> property litigation status in Anambra
          State—backed by accurate data and legal <br /> transparency.
        </p>
        <button
          onClick={() => navigate("/search")}
          className="w-fit hover:scale-95 transition-all duration-300 bg-globalGold px-5 py-2 rounded-3xl flex items-center justify-center gap-x-2"
        >
          <img src={SEARCH_INPUT_WHITE} className="w-[20px] h-[20px]" alt="" />
          <span className="text-[16px] font-medium text-white">
            Search Property
          </span>
        </button>
      </motion.div>
    </div>
  );
}

export default Hero;
